export default __webpack_public_path__ + "static/media/enterprisePlanLogo.de378381.svg";